module.exports = __webpack_public_path__ + "static/gallery-8@2x-dd8a350b1605f6836303d2157338a35c.jpg";